import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import jwtTokenSlice from './slices/jwtTokenSlice';
import expertsSlice from './slices/expertsSlice';
import queueSlice from './slices/queueSlice';
import navbarSlice from './slices/navbarSlice';
import viewModeSlice from './slices/viewModeSlice';

const rootReducer = combineReducers({
  jwtToken: jwtTokenSlice,
  experts: expertsSlice,
  queue: queueSlice,
  navbar: navbarSlice,
  viewMode: viewModeSlice,
});

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
